import { render } from "./Sites.vue?vue&type=template&id=76534cfe&scoped=true&bindings={\"newSiteUrl\":\"data\",\"wasValidated\":\"data\",\"sites\":\"data\",\"activeWorkspaceId\":\"options\",\"addNewSiteBtnDisabled\":\"options\",\"getSites\":\"options\",\"postAddSite\":\"options\",\"deleteSite\":\"options\"}"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"

import "./Sites.vue?vue&type=style&index=0&id=76534cfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76534cfe"

export default script